// Necklace / Pendant sets: unsold pieces sharing the jewellery number before the last dash.
// necklace (+ pendant) + earrings -> Necklace Set; pendant + earrings -> Pendant Set. Roles come from the
// super admin's Jewellery types console. Pieces sold separately drop out and count as their own type.
export const SET_ROLES = [['necklace', 'Necklace'], ['pendant', 'Pendant'], ['earring', 'Earrings']];

const baseOf = (no) => { const s = String(no || '').trim(); const i = s.lastIndexOf('-'); return i > 0 ? s.slice(0, i).trim().toUpperCase() : ''; };

// Built-in roles by type name; the console can override any type (or set it to 'none').
export function defaultRole(type) {
  const t = String(type || '').toLowerCase();
  if (/ear\s*-?\s*rings?|jhum|studs?\b|\btops\b|bali/.test(t)) return 'earring';
  if (/pend[ae]nt/.test(t)) return 'pendant';
  if (/neck\s*-?\s*lace|choker|haar|mala\b|collar/.test(t)) return 'necklace';
  return '';
}

export const roleOf = (roles, type) => {
  const r = (roles || {})[type];
  return r === 'none' ? '' : r || defaultRole(type);
};

let ROLES = {};
// Roles from the workspace context, so dashboards outside the page component can group sets too.
export const setSetRoles = (r) => { ROLES = r || {}; };

// Generic grouping: entries {key, no, type, group}. Pieces match when their numbers are the same apart
// from one letters-only part (1004-NK-RD-144 / 1004-ER-RD-144, NT02749-N / NT02749-E), or share the part
// before the last dash (older rule).
const keysOf = (no) => {
  const t = String(no || '').trim().toUpperCase().split('-').map((x) => x.trim());
  if (t.length < 2) return [];
  const keys = t.map((x, i) => (/^[A-Z]+$/.test(x) ? t.map((y, k) => (k === i ? '*' : y)).join('-') : '')).filter(Boolean);
  const b = baseOf(no);
  return b ? [...keys, `${b}|last`] : keys;
};

export function lineSets(entries, roles = ROLES) {
  const groups = new Map();
  const mine = [];
  entries.forEach((e) => {
    const role = roleOf(roles, e.type);
    if (!role) return;
    const ks = keysOf(e.no).map((k) => `${e.group || ''}|${k}`);
    ks.forEach((g) => (groups.get(g) || groups.set(g, []).get(g)).push(role));
    mine.push([e.key, ks]);
  });
  const nameOf = (g) => {
    const list = groups.get(g) || [];
    if (!list.includes('earring')) return '';
    return list.includes('necklace') ? 'Necklace Set' : list.includes('pendant') ? 'Pendant Set' : '';
  };
  const tag = new Map();
  mine.forEach(([k, ks]) => {
    const g = ks.find((x) => nameOf(x));
    if (g) tag.set(k, { set_type: nameOf(g), set_id: `set:${g}` });
  });
  return tag;
}

export function annotateSets(items, roles = ROLES) {
  const tag = lineSets(items.filter((j) => !j.sold && !j.tagws_hidden).map((j) => ({ key: j.id, no: j.jewellery_no, type: j.jewellery_type })), roles);
  return tag.size ? items.map((j) => (tag.has(j.id) ? { ...j, ...tag.get(j.id) } : j)) : items;
}
